import './src/shared/_shared/Index.scss';
import { createOnPreRouteUpdate } from './src/shared/gatsby/browser-utils';

export const onPreRouteUpdate = createOnPreRouteUpdate ()